export function ErrorIcon() {
  return (
    <div className="text-soClean-100 bg-roses mr-1 size-3 rounded-full text-center">
      !
    </div>
  );
}
